import { render, staticRenderFns } from "./gps_new.vue?vue&type=template&id=61004a1a&scoped=true"
import script from "./gps_new.vue?vue&type=script&lang=js"
export * from "./gps_new.vue?vue&type=script&lang=js"
import style0 from "./gps_new.vue?vue&type=style&index=0&id=61004a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61004a1a",
  null
  
)

export default component.exports